module.exports = __webpack_public_path__ + "static/media/badge_level_2_2.ed16d283.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_2_2.png
// module id = 501
// module chunks = 0